import ValidationError from '../models/validationError';
/**
         * Maintain a list of validation errors at the application level
         */

var ValidationErrorList = Backbone.Collection.extend({model: ValidationError, initialize: function( ) {}});

export default ValidationErrorList;
